import React from "react";
import clsx from "clsx";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "primary" | "success" | "warning" | "danger" | "info";
  size?: "sm" | "md" | "lg";
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, variant = "default", size = "md", className }) => {
  const variantClasses = {
    default: "bg-neutral-100 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-100",
    primary: "bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-200",
    success: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200",
    warning: "bg-amber-100 text-amber-900 dark:bg-amber-900/30 dark:text-amber-200",
    danger: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-200",
    info: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200",
  };

  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-1 text-sm",
    lg: "px-3 py-1.5 text-base",
  };

  return (
    <span
      className={clsx(
        "inline-flex items-center font-medium rounded-full",
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
